import Loadable from "../../../../Loadable";
import { jsx as _jsx } from "react/jsx-runtime";
var LazyDegreeLayout = function LazyDegreeLayout() {
  return /*#__PURE__*/_jsx(Loadable, {
    module: function module() {
      return import(/* webpackChunkName: "home-user-degree-layout" */"./DegreeLayout");
    }
  });
};
export default LazyDegreeLayout;